<template>
  <div v-if="order.shipping" class="space-y-8">
    <div>
      <RevTag
        v-if="order.shipping.carrier.isBackship"
        class="mr-8 align-middle"
        :label="i18n(translations.backship)"
        variant="primary"
      />
      {{ order.shipping.carrier.name }}
    </div>

    <div>
      <div class="caption">
        {{ i18n(translations.price) }}
      </div>
      <div class="body-2">
        <span v-if="parseInt(order.shipping.price.amount, 10) > 0">
          {{ i18n.price(order.shipping.price) }}
        </span>
        <span v-else>
          {{ i18n(translations.free) }}
        </span>
      </div>
    </div>

    <ExpectedDispatchDate
      :dispatchDate="order.shipping.expectedDispatchDate"
      :market="order.market"
    />
    <Pickup :order :refreshOrders />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTag } from '@ds/components/Tag'

import type { Order } from '../../../../Tab.types'

import translations from './ShippingCell.translations'
import ExpectedDispatchDate from './components/ExpectedDispatchDate/ExpectedDispatchDate.vue'
import Pickup from './components/Pickup/Pickup.vue'

const i18n = useI18n()

defineProps<{ order: Order; refreshOrders: () => void }>()
</script>
